import { Background } from '@fhs/ui';
type AuthHeaderProps = {
  height?: number;
  repeat?: number;
};

export function AuthHeader({ height, repeat }: AuthHeaderProps): React.JSX.Element {
  return <Background backgroundHeight={height} repeat={repeat} />;
}
